"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
const Calendar = () => {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    width: "24px",
    height: "24px",
    version: "1.0",
    viewBox: "0 0 76 78",
    xmlns: "http://www.w3.org/2000/svg",
    className: "MuiSvgIcon-root"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0 76) scale(.1 -.1)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "m169 673c-1-4-2-17-3-28-1-17-9-20-58-23l-58-3v-244c0-134-3-250-6-258s2-22 11-31c14-14 51-16 295-16s281 2 295 16c14 15 16 45 11 271-2 140-7 258-11 261-3 3-29 6-58 7-49 0-52 2-52 25 0 18-6 25-20 25s-20-7-20-25v-25h-145-145v25c0 23-33 44-36 23zm-1-115c4-36 30-36 34 0l3 27h145 145l3-27c2-16 9-28 17-28s15 12 17 28c3 24 7 27 43 27h40v-55-55h-265-265l-3 44c-5 63 2 73 45 69 33-3 38-7 41-30zm447-282v-158l-265-1-265-1-3 149c-1 82 0 155 2 162 4 10 64 12 268 9l263-2v-158z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m140 321v-59l63-4c34-2 67-2 74 0 18 6 24 32 17 79l-6 43h-74-74v-59zm115-1c0-22-5-25-38-28-26-2-39 1-43 12-12 31 4 47 43 44 33-3 38-6 38-28z"
  })));
};
var _default = exports.default = Calendar;